import { Injectable } from '@angular/core';
import { nlSearchResoponse } from './hire-search/hire-search.component';
import { FilterParams } from '../common-interfaces-classes/FilterParams';
import * as _ from 'underscore';
import { jdParserResponse } from '../person-search/jd-search/jd-search.component';
import { Similarobject } from '../_services/person-search.service';
import { SCPassData } from '../ai-modal-sc/ai-modal-sc.component';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class FilterResponseMapperServiceService {

  constructor(private router: Router) { }
  /**
   * Maps the NL response to filter parameters.
   */
mapNlResponseToFilters(response: nlSearchResoponse): Partial<FilterParams> {
  const data = response.data;
  const mergedJobtitles = data?.jobtitles.concat(data?.suggestedjobtitle || []);
  const locations = _.pluck(data?.normalizedlocations, 'exactlocationmatch');
  const continents = _.pluck(data?.normalizedlocations, 'continent');
  const skills = data?.preferredskills?.map(s => this.prepareFilterChipData(s)).concat(data?.mandatoryskills?.map(s => this.prepareFilterChipData(s))).concat(data?.tools?.map(t => this.prepareFilterChipData(t)) ?? []) ?? [];

  return {
    jobTitleSelectedList: mergedJobtitles?.map(j => this.prepareFilterChipData(j)) ?? [],
    companySelectedList: data.companies?.map(c => this.prepareFilterChipData(c)) ?? [],
    skillsSelectedList: skills,
    industrySelectedList: data.industries?.map(i => this.prepareFilterChipData(i)) ?? [],
    locationSelectedList: locations?.map(l => this.prepareFilterChipData(l)) ?? [],
    continentstobeincluded: continents ?? [],
    yearsofexperienceFrom: data.yearsofexperience?.min ?? null,
    yearsofexperienceTo: data.yearsofexperience?.max ?? null,
    locationcontinents: data?.normalizedlocations?.map(l => ({key: l.exactlocationmatch, continent: l.continent})) ?? [],
    jobTitleStatus: "All",
    companyStatus: "All",
    industryStatus: "All",
    distancefromselectedlocations: 100,
    distancefromselectedlocationsmeasurementunit: 'kilometers',
  };
}

    /**
     * prepare Filter chip data for person suggestions
     */
    prepareFilterChipData(value: string, ismandatory: boolean = false): any {
      return {
        key: value,
        isExcluded: false,
        isMandatory: ismandatory,
        chipkey: value
      }
    }


      /**
   * Maps the JD response to filter parameters.
   */
mapJDResponseToFilters(response: jdParserResponse): Partial<FilterParams> {
  const data = response.data;
  const mergedJobtitles = data?.jobtitles.concat(data?.suggestedjobtitle || []);
  const locations = _.pluck(data?.normalizedlocations, 'exactlocationmatch');
  const continents = _.pluck(data?.normalizedlocations, 'continent');
  const skills = data?.preferredskills?.map(s => this.prepareFilterChipData(s)).concat(data?.mandatoryskills?.map(s => this.prepareFilterChipData(s))).concat(data?.tools?.map(t => this.prepareFilterChipData(t)) ?? []) ?? [];

  return {
    jobTitleSelectedList: mergedJobtitles?.map(j => this.prepareFilterChipData(j)) ?? [],
    companySelectedList: data.companies?.map(c => this.prepareFilterChipData(c)) ?? [],
    skillsSelectedList: skills,
    industrySelectedList: data.industries?.map(i => this.prepareFilterChipData(i)) ?? [],
    locationSelectedList: locations?.map(l => this.prepareFilterChipData(l)) ?? [],
    continentstobeincluded: continents ?? [],
    yearsofexperienceFrom: data.yearsofexperience?.min ?? null,
    yearsofexperienceTo: data.yearsofexperience?.max ?? null,
    locationcontinents: data?.normalizedlocations?.map(l => ({key: l.exactlocationmatch, continent: l.continent})) ?? [],
    companyStatus: "All",
    industryStatus: "All",
      distancefromselectedlocations: 100,
    distancefromselectedlocationsmeasurementunit: 'kilometers',
  };
}

mapSimilarCandidateResponseToFilters(response: SCPassData): Partial<FilterParams> {
  const data = response.data;
  const mergedJobtitles = data?.jobtitle.map(j => j.key) ?? [];
    // const locations = _.pluck(data?.normalizedlocations, 'exactlocationmatch');
    // const continents = _.pluck(data?.normalizedlocations, 'continent');
    // const skills = data?.preferredskills?.map(s => this.prepareFilterChipData(s)).concat(data?.mandatoryskills?.map(s => this.prepareFilterChipData(s,true))).concat(data?.tools?.map(t => this.prepareFilterChipData(t)) ?? []) ?? [];

    return {
      jobTitleSelectedList: mergedJobtitles?.map(j => this.prepareFilterChipData(j)) ?? [],
      skillsSelectedList: data.skills?.map(s => this.prepareFilterChipData(s.key)) ?? [],
    locationSelectedList: data.currentlocation?.map((l:any) => this.prepareFilterChipData(l.key)) ?? [],
    continentstobeincluded: data.locationcontinent ? [data.locationcontinent] : [],
    yearsofexperienceFrom: data.fromYrsOfExperience ?? null,
    yearsofexperienceTo: data.toYrsOfExperinece ?? null,
    companysize: data.companysize?.map(cs => (cs.key)) ?? [],
    companySizeSelectedList: data.companysize?.map(cs => this.prepareFilterChipData(cs.key)) ?? [],
    locationcontinents: data.currentlocation?.map((l:any) => ({key: l.key, continent: data.locationcontinent ? data.locationcontinent : ''})) ?? [],
    linkedinurl: data.linkedinurl ?? '',
    isUploadedFromResume: data.isUploadedFromResume ?? false,
    jobTitleStatus: "All",
    similarcandidates_excludefirstname: data?.firstname ? data?.firstname : '',
    similarcandidates_excludelastname: data?.lastname ? data?.lastname : '',
    similarcandidates_jobtitles: data?.jobtitle ? data?.jobtitle : [],
    similarcandidates_companies: data?.jobcompanyname ? data?.jobcompanyname : [],
      distancefromselectedlocations: 100,
    distancefromselectedlocationsmeasurementunit: 'kilometers',

  }
}

isHireSearchListing() {
    const url = this.router.url;
    return (url?.startsWith("/candidate-list") || url?.startsWith("/search"));
  }

}

